import React, { FC, useRef, useEffect, useState } from "react";
import styled from "styled-components";
import { GRAY, RED } from "../styles/constants";
import Link from "next/link";
import Icon from "./Icon";
import dayjs from "dayjs";

interface Props {
  clamp?: boolean;
  resized?: number;
  listItem: any;
  appraisal?: any;
}

const Review: FC<Props> = ({
  resized,
  clamp,
  listItem,
  appraisal,
  ...props
}) => {
  const [overflow, setOverflow] = useState(false);
  const textWrapRef = useRef(null);
  const textRef = useRef(null);
  const { fullName, createdAt, feedback, type } = listItem;

  const big = feedback.length <= 48;

  useEffect(() => {
    if (big || resized === undefined || !clamp) {
      return;
    }
    const wrapHeight = textWrapRef.current.offsetHeight;
    const textHeight = textRef.current.offsetHeight;
    setOverflow(textHeight > wrapHeight);
  }, [resized, textWrapRef, textRef]);

  return (
    <Item {...props}>
      <Top>
        <div>
          <Name>{fullName}</Name>
          <Date>{dayjs(createdAt).format("D MMMM YYYY")}</Date>
        </div>
        <Icon code={type} />
      </Top>
      <TextWrap ref={textWrapRef} big={big} clamp={clamp}>
        <Text ref={textRef}>{feedback}</Text>
        {overflow ? (
          <Link href="/">
            <Overflow href="/">… Читать далее</Overflow>
          </Link>
        ) : null}
      </TextWrap>
    </Item>
  );
};

const Item = styled.div`
  border-radius: 18px;
  background-color: #fff;
  padding: 30px;
  min-height: 210px;
  @media (max-width: 450px) {
    padding: 20px;
    min-height: initial;
  }
`;

const Top = styled.div`
  display: flex;
  margin-bottom: 1rem;
  justify-content: space-between;
  align-items: center;
`;

const Name = styled.p`
  font-size: 18px;
  font-weight: bold;
  margin: 0;
`;

const Date = styled.p`
  font-size: 14px;
  margin: 0;
  color: ${GRAY};
`;

interface TextWrapProps {
  big: boolean;
  clamp?: boolean;
}
const TextWrap = styled.div<TextWrapProps>`
  position: relative;
  overflow: hidden;
  font-size: ${({ big }) => (big ? "28px" : "inherit")};
  line-height: ${({ big }) => (big ? "1.4" : "inherit")};
  max-height: ${({ big, clamp }) =>
    big || !clamp ? "none" : "calc(1.6em * 4)"};

  @media (max-width: 450px) {
    font-size: ${({ big }) => (big ? "23px" : "inherit")};
  }
`;

const Text = styled.p``;

const Overflow = styled.a`
  position: absolute;
  padding-left: 20px;
  padding-right: 10px;
  right: 0;
  bottom: 0;
  display: inline-block;
  transition: 0.2s ease-in-out;
  color: ${RED};
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.001),
    #fff 15%,
    #fff
  );
`;

export default Review;
